import CityPageTemplate from "../city-template/CityPageTemplate";
import { westFargoConfig } from "./data";

export default function WestFargoPage() {
  return <CityPageTemplate config={westFargoConfig} />;
}